import type React from 'react';

interface ExcelIconProps {
	width?: number;
	height?: number;
}

const ExcelIcon: React.FC<ExcelIconProps> = ({ width = 44, height = 45 }) => {
	return (
		<svg
			width={width}
			height={height}
			viewBox="0 0 44 45"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			role="img"
			aria-label="Excel file icon"
		>
			<path
				d="M34.344 0.112793L43.0958 9.23583V43.9285H10.4023V44.0418H43.2075V9.35065L34.344 0.112793Z"
				fill="#909090"
			/>
			<path
				d="M34.2378 0H10.293V43.929H43.0981V9.23786L34.2378 0Z"
				fill="#F4F4F4"
			/>
			<path
				d="M10.0511 2.35938H0V13.0978H31.616V2.35938H10.0511Z"
				fill="#7A7B7C"
			/>
			<path
				d="M31.783 12.9153H0.203125V2.16895H31.783V12.9153Z"
				fill="#107C41"
			/>
			<path
				d="M8 6L11.5 10L8 14H10L12.5 11L15 14H17L13.5 10L17 6H15L12.5 9L10 6H8Z"
				fill="white"
			/>
			<path d="M19 6V8H25V6H19Z" fill="white" />
			<path d="M19 9V11H25V9H19Z" fill="white" />
			<path d="M19 12V14H25V12H19Z" fill="white" />
			<path d="M15 18H38V22H15V18Z" fill="#C6E0B4" />
			<path d="M15 23H38V27H15V23Z" fill="#E2EFD9" />
			<path d="M15 28H38V32H15V28Z" fill="#C6E0B4" />
			<path d="M15 33H38V37H15V33Z" fill="#E2EFD9" />
			<path
				d="M34.1172 0.121582V9.35944H42.9775L34.1172 0.121582Z"
				fill="#909090"
			/>
			<path d="M34.2344 0V9.23786H43.0947L34.2344 0Z" fill="#F4F4F4" />
		</svg>
	);
};

export default ExcelIcon;
